import { render, staticRenderFns } from "./user.vue?vue&type=template&id=2dffddff&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"
import style0 from "./user.vue?vue&type=style&index=0&id=2dffddff&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dffddff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dffddff')) {
      api.createRecord('2dffddff', component.options)
    } else {
      api.reload('2dffddff', component.options)
    }
    module.hot.accept("./user.vue?vue&type=template&id=2dffddff&scoped=true", function () {
      api.rerender('2dffddff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/navBars/breadcrumb/user.vue"
export default component.exports